<template>
  <div>
    <div v-if="!loading">
      <div ref="test" class="row" style="margin: 0px">
        <div v-if="!isMobile() && items.length > 0 && (filter_mode=='bookingType' || filter_mode=='routes' || filter_mode=='clientID')" class="col" style="overflow-y:scroll; max-height: 900px; max-width: 360px; border: 1px solid grey;">
          <div v-if="route_name_options.length > 2" style="margin:10px; font-size: 20px; font-weight: bold" class="d-flex align-items-center justify-content-center">
            Route:&nbsp;<b-form-select v-model="selected_route_name" :options="route_name_options" style="font-size: 16px; width:260px"/>
          </div>
          <div v-if="items.length > 0" @click="toggle_div(veh, veh.name,'detailsVisible')" v-for="(veh,idx) in items" style="font-size: 18px;text-align: left; padding:10px">
            <span v-if="veh.gps.speedMilesPerHour == 0" style="color: darkred; font-size: 18px; font-weight: bold">{{veh.name | trim(30)}}</span>
            <span v-else style="color: green; font-size: 18px; font-weight: bold">{{veh.name | trim(25)}}</span>
            <span v-if="veh.route_name" style="font-size: 16px; font-weight: bold"> - {{veh.route_name}}</span>
            <br/>
          </div>
          <div v-if="items.length == 0" style="font-size: 18px;border-top: 1px solid grey; text-align: left; padding:10px">
            <span v-if="!summary.route_names || summary.route_names.length == 0" style="color: darkred; font-size: 18px; font-weight: bold">no {{filter_value}} vehicle routes are currently in service</span>
          </div>
        </div>
        <div v-if="items.length > 0" class="col" style="border: none; padding-right:0px !important; padding-left:0px !important">
          <div v-if="isMobile() && filter_mode=='bookingType'" style="margin:5px; font-size: 20px; font-weight: bold" class="d-flex align-items-center justify-content-center">
            Route:&nbsp;<b-form-select v-model="selected_route_name" :options="route_name_options" style="font-size: 18px; width:250px"/>
          </div>
          <GmapMap id="map" ref="mapRef"
                   :zoom="zoom"
                   :center="center"
                   :options="mapStyle"
                   style="width:100%;  height: 900px;"
          >
            <GmapMarker
                v-for="(marker, idx) in markers"
                :key="idx"
                :position="marker.position"
                :title="marker.title"
                :label="marker.label"
                :draggable="false"
                :clickable="true"
                :icon="marker.icon"
                @mouseover="openInfoWindowTemplate(marker.title)"
                @mouseout="infoWindow.open=false"
            />
            <GmapInfoWindow
                :options="{pixelOffset: { width: 0, height: -65 }}"
                :position="infoWindow.position"
                :opened="infoWindow.open"
            >
              <div v-html="infoWindow.template"></div>
            </GmapInfoWindow>

          </GmapMap>
        </div>
        <div v-else-if="filter_mode=='booking' || filter_mode=='bookingETA' || filter_mode=='movement'">
          <b>This link is only active {{summary.minutes_before}} minutes prior to the start of the charter through {{summary.minutes_after}} minutes after completion.  Please try the link again during that time.</b>
        </div>
        <div style="padding: 20px; font-weight: bold; font-size: 22px" v-else>
          <b>vehicle locations are currently unavailable</b>
        </div>
      </div>
    </div>
    <div v-if="loading">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>
</template>
<script>
import {get_vehicle_track_fleet, get_vehicle_track_reload} from '../networking/apis'
import {get_vehicle_track_fleet_tbn} from '../networking/tbn_apis'

export default {
  name: 'vehicle_map_track_fleet',
  components: {
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      tenant_id: null,
      filter_mode: '',
      filter_value: '',
      items: [],
      items_full: [],
      tenant_type: 'CM',
      loading: true,
      reload_enabled: true,
      follow_enabled: true,
      center: null,
      zoom: null,
      markers: [],
      markers_full: [],
      reload_interval: 10000,
      reload_center: null,
      bounds: null,
      timer: null,
      reload_inflight: false,
      selected_route_name: '',
      route_name_options: [],
      infoWindow: {
        position: {lat: 0, lng: 0},
        open: false,
        template: ''
      },
      mapStyle: {
        styles: [
          {
            "featureType": "landscape",
            "stylers": [
              { "color": "#F3F4F9" }
            ]
          },          {
            "featureType": "water",
            "stylers": [
              { "color": "#C1CDE4" }
            ]
          },
          {
            "featureType": "landscape.natural.terrain",
            "stylers": [
              { "color": "#E0EDCA" }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [{color: '#DDDDDD'}]
          },
          {
            featureType: 'road',
            elementType: 'geometry.fill',
            stylers: [{color: '#FFFFFF'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [{color: '#FEF8D6'}]
          },
          {
            featureType: 'transit',
            stylers: [{"visibility": "off"}]
          },
          {
            featureType: 'poi',
            stylers: [{"visibility": "off"}]
          },
        ]
      }
    }
  },
  async created() {
    this.check_features()
  },
  async mounted () {
    this.stopTimer();
  },
  beforeDestroy() {
    this.stopTimer();
  },
  methods: {
    startTimer() {
      this.stopTimer();
      this.timer = setInterval(() => this.reload_data(), this.reload_interval);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    async resetTimerAndReload() {
      this.stopTimer();
      await this.reload_data();
      this.startTimer();
    },

    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    async check_features() {

      this.tenant_id = this.$route.path.split('/fleet-track/')[1].split("/")[0]
      this.filter_mode = this.$route.path.split('/fleet-track/')[1].split("/")[1]
      this.filter_value = this.$route.path.split('/fleet-track/')[1].split("/")[2]
      if (this.$route.path.split('/fleet-track/')[1].split("/").length > 4) {
        this.filter_value += '/' + this.$route.path.split('/fleet-track/')[1].split("/")[3]
        this.tenant_type = this.$route.path.split('/fleet-track/')[1].split("/")[4]
      }
      else if (this.$route.path.split('/fleet-track/')[1].split("/").length > 3)
        this.tenant_type = this.$route.path.split('/fleet-track/')[1].split("/")[3]

      if (this.filter_mode == 'yard') {
        this.mapStyle = { "mapTypeId": "satellite", "tilt": 0 }
        this.reload_interval = 60000
      }
      else if (this.filter_mode == 'vsm') {
        this.reload_interval = 60000
      }
      else if (this.filter_mode == 'bookingETA') {
        this.reload_interval = 120000
      }
      else if (this.filter_mode == 'fullfleetoverview') {
        this.reload_interval = 120000
      }
      else if (this.filter_mode == 'routes') {
        this.reload_interval = 120000
      }

      this.load_data()
    },
    openInfoWindowTemplate(selected_name) {
      const loc = this.items.filter(item => item.name == selected_name)[0]

      if (loc != null) {
        const position = {
          lat: Number(loc.gps.latitude),
          lng: Number(loc.gps.longitude),
        };
        this.infoWindow.position = position
        this.infoWindow.template = loc.marker_html
        this.infoWindow.open = true
      }
    },
    toggle_div(item,selected_name,field) {
      // item[field] = !item[field];
      // this.$forceUpdate();

      const loc = this.items.filter(item => item.name == selected_name)[0]
      if (loc != null) {
        this.center = {
          lat: Number(loc.gps.latitude),
          lng: Number(loc.gps.longitude),
        };
        this.zoom = 13
      }
    },
    async load_data() {
      this.loading = true
      try {
        let results = null;

        if (this.tenant_type=='CM')
          results = await get_vehicle_track_fleet(this.tenant_id,this.filter_mode,this.filter_value)
        else
          results = await get_vehicle_track_fleet_tbn(this.tenant_id,this.filter_mode,this.filter_value)

        const {value: { data = [] } } = results

        this.summary = data.summary
        this.route_name_options = data.summary.route_names
        this.items = data.results
        this.items_full = data.results

        if (this.items.length == 0) {
          const position = {
            lat: Number('39.917742615494085'),
            lng: Number('-97.13906071185122'),
          };
          this.center = position;
          this.zoom = 5
          this.loading = false;
        } else {
          this.zoom = this.summary.zoom
          if (this.items && this.items.length > 0) {
            let idx = 0
            for (const loc of this.items) {
              idx += 1
              const position = {
                lat: Number(loc.gps.latitude),
                lng: Number(loc.gps.longitude),
              };
              if (this.center == null) {
                this.center = position;
                this.reload_center = position;
              }
              let marker_title = loc.name

              if (this.filter_mode == 'yard')
                marker_title = loc.name

              if (loc.route_name != null) {
                marker_title += " - " + loc.route_name;
              }

              if (loc.pickup_address) {
                const pickup_position = {
                  lat: Number(loc.pickup_lat),
                  lng: Number(loc.pickup_lon),
                };
                this.markers.push({position: pickup_position, title: 'pickup', label: {text: loc.pickup_address, className: 'addr-label-' + idx}, icon: this.mapSymbol("green")});
              }

              if (loc.destination_address) {
                const destination_position = {
                  lat: Number(loc.destination_lat),
                  lng: Number(loc.destination_lon),
                };
                this.markers.push({position: destination_position, title: 'destination', label: {text: loc.destination_address, className: 'addr-label-' + idx}, icon: this.mapSymbol("orange")});
              }

              if (loc.dropoff_address && (loc.dropoff_lat != loc.pickup_lat && loc.dropoff_lon != loc.pickup_lon)) {
                const pickup_position = {
                  lat: Number(loc.dropoff_lat),
                  lng: Number(loc.dropoff_lon),
                };
                this.markers.push({position: pickup_position, title: 'dropoff', label: {text: loc.dropoff_address, className: 'addr-label-' + idx}, icon: this.mapSymbol("red")});
              }

              if (loc.eta)
                marker_title += " (" + loc.eta + ")"

              this.markers.push({
                position: position,
                heading: loc.gps.headingDegrees,
                title: marker_title,
                bus_name: loc.name,
                route_name: loc.route_name,
                label: {text: marker_title, className: 'tracking-label'},
                icon: this.arrowSymbol(loc.gps)
              });

            }
          }

          this.zoom = 10
          this.markers_full = this.markers
          this.loading = false

          if (this.markers.length > 1)
            this.fitMapToMarkers()
        }

        this.startTimer();

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

    },
    async fitMapToMarkers() {
      if (!this.$refs.mapRef) {
        let cnt=0;
        while(cnt<10) {
          if (this.$refs.mapRef)
            break;
          await this.sleep(500);
          console.log("waiting for mapref: " + cnt)
          cnt++;
        }
      }

      this.bounds = new google.maps.LatLngBounds();
      for (const marker of this.markers)
        this.bounds.extend(marker.position);

      this.$refs.mapRef.$mapObject.fitBounds(this.bounds);
    },
    async reload_data() {
      console.log("reload_data()")
      try {
        if (this.$pageVisibility && this.$pageVisibility.hidden) {
          return
        }

        if (!this.reload_enabled) {
          console.log("reload disabled")
          return
        }

        if (this.reload_inflight) {
          console.log("reload already in-flight; skipping");
          return;
        }
        this.reload_inflight = true;

        let results = null;

        if (this.tenant_type=='CM')
          results = await get_vehicle_track_reload(this.tenant_id,this.filter_mode,this.filter_value)
        else
          results = await get_vehicle_track_fleet_tbn(this.tenant_id,this.filter_mode,this.filter_value)

        const {value: { data = [] } } = results

        if (data.results.length === 0) {
          return;
        }

        this.summary = data.summary
        this.items = data.results
        this.items_full = data.results
        this.route_name_options = data.summary.route_names

        if (this.items.length == 0) {
          return;
        }

        this.filter_items()
        if (this.items && this.items.length > 0) {
          let idx = 0
          for (const loc of this.items) {
            idx += 1
            const position = {
              lat: Number(loc.gps.latitude),
              lng: Number(loc.gps.longitude),
            };

            let current_marker_idx = this.markers.findIndex(x => x.bus_name === loc.name);
            let pickup_idx = this.markers.findIndex(x => x.title === 'pickup');
            let destination_idx = this.markers.findIndex(x => x.title === 'destination');
            let dropoff_idx = this.markers.findIndex(x => x.title === 'dropoff');

            let marker_title = loc.name;
            if (loc.route_name != null)
              marker_title += " - " + loc.route_name;

            if (loc.eta)
              marker_title += " (" + loc.eta + ")"

            if (pickup_idx != -1) {
              this.markers[pickup_idx].label = {text: loc.pickup_address, className: 'addr-label-' + idx};
              this.markers[destination_idx].label = {text: loc.destination_address, className: 'addr-label-' + idx};
              this.markers[dropoff_idx].label = {text: loc.dropoff_address, className: 'addr-label-' + idx};
            }

            if (current_marker_idx == -1) {
              this.markers.push({position: position, heading: loc.gps.headingDegrees, title: marker_title, bus_name: loc.name, route_name: loc.route_name, label: {text: marker_title, className: 'tracking-label'}, icon: this.arrowSymbol(loc.gps)});
              current_marker_idx = this.markers.findIndex(x => x.bus_name === loc.name);
            } else {
              if (marker_title != this.markers[current_marker_idx].title) {
                this.markers[current_marker_idx].label = {text: marker_title, className: 'tracking-label'};
              }
            }

            this.animatedMove(this.markers[current_marker_idx], loc.gps);
          }
        }

        //remove any markers that no longer exist
        let markers_to_remove = []
        for (const old_marker of this.markers) {
          let marker_idx = this.items.findIndex(x => x.name === old_marker.bus_name);
          if (marker_idx == -1 && old_marker.bus_name.indexOf('pickup') == -1)
            markers_to_remove.push(old_marker.bus_name);
        }
        if (markers_to_remove.length > 0) {
          console.log("markers_to_remove:" + markers_to_remove);
          this.markers = this.markers.filter(item => !markers_to_remove.includes(item.bus_name))
        }

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      } finally {
        this.reload_inflight = false;
      }

    },
    animatedMove(marker, new_loc) {

      const new_position = {
        lat: Number(new_loc.latitude),
        lng: Number(new_loc.longitude),
      };

      let new_heading = Number(new_loc.headingDegrees);
      let old_heading = marker.icon.rotation;

      //console.log("heading change: old = " + old_heading + ", new = " + new_heading);

      if (new_heading == 0)
        new_heading = marker.icon.rotation;
      if (old_heading == 0 || isNaN(old_heading))
        marker.icon.rotation = new_heading;

      marker.speed = new_loc.speedMilesPerHour;

      var delta_incr = 200;

      var deltalat = (new_position.lat - marker.position.lat) / delta_incr;
      var deltalng = (new_position.lng - marker.position.lng) / delta_incr;
      var deltaheading = (new_heading - marker.icon.rotation) / delta_incr;

      var direction = 'clockwise';
      if (new_heading > old_heading) {
        if ((new_heading - old_heading) > 180) {
          direction = 'counterclockwise';
          deltaheading = (old_heading + (360-new_heading)) / delta_incr;
        } else {
          deltaheading = (new_heading - old_heading) / delta_incr;
        }
      } else if (old_heading > new_heading) {
        if ((old_heading - new_heading) > 180) {
          deltaheading = (new_heading + (360-old_heading)) / delta_incr;
        } else {
          deltaheading = (old_heading - new_heading) / delta_incr;
          direction = 'counterclockwise';
        }
      }

      if (Math.abs(old_heading - new_heading) < 2)
        deltaheading = 0;

      //console.log("direction: " + direction + ":" + Math.round(deltaheading * delta_incr));

      var delay = this.reload_interval/delta_incr;

      //console.log("heading adjust: old = " + Number(old_heading) + ", new = " + Number(new_heading) + ", deltas: lat " + deltalat + ", lon " + deltalng + ", heading: " + deltaheading + ", delay: " + delay);

      for (var i = 0; i < delta_incr; i++) {
        (function(ind) {
          setTimeout(
              function() {
                let incr_position = {
                  lat: (marker.position.lat + deltalat),
                  lng: (marker.position.lng + deltalng),
                };
                marker.position = incr_position;

                if (deltaheading != 0) {
                  if (direction == 'clockwise')
                    marker.icon.rotation = Number(marker.icon.rotation + deltaheading);
                  else
                    marker.icon.rotation = Number(marker.icon.rotation - deltaheading);

                  if (marker.icon.rotation > 360) {
                    //console.log("resetting >360 to 0");
                    marker.icon.rotation = 0;
                  }

                  if (Math.floor(marker.icon.rotation) != (Math.floor(marker.icon.rotation + deltaheading))) {
                    //console.log("-->rotating: " + marker.icon.rotation)
                    marker.icon =
                        {
                          path: (new_loc.speedMilesPerHour == 0 || new_heading == 0) ? "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0" : "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
                          scale: 1.5,
                          strokeColor: "white",
                          strokeStyle: "bold",
                          fillColor: new_loc.speedMilesPerHour == 0 ? "darkred" : "#29C68A",
                          fillOpacity: .6,
                          rotation: marker.icon.rotation
                        }
                  }
                }
              }, delay * ind
          );
        })(i)
      }
    },
    mapSymbol(color) {
      return {
        path: "M-1.547 12l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM0 0q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
        fillColor: color,
        fillOpacity: 0.6,
        strokeWeight: 0,
        rotation: 0,
        scale: 1.5,
      }
    },
    arrowSymbol(loc) {
      return {
        path: (loc.speedMilesPerHour == 0 || loc.headingDegrees == 0) ? "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0" : "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
        scale: 1.5,
        strokeColor: "white",
        strokeStyle: "bold",
        fillColor: loc.speedMilesPerHour == 0 ? "darkred" : "#29C68A",
        fillOpacity: 1,
        rotation: Number(loc.headingDegrees)
      }
    },
    pinSymbol(color) {
      return {
        path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
        fillColor: color,
        fillOpacity: 1,
        strokeColor: 'black',
        strokeWeight: 1,
        scale: 1.5,
      };
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    filter_items() {
      this.items = this.items_full
      this.markers_new = this.markers_full
      if (this.selected_route_name != '') {
        this.items = this.items.filter(item => this.contains(item.route_name, this.selected_route_name))
        this.markers_new = this.markers_new.filter(item => this.contains(item.route_name, this.selected_route_name))
      }
      this.markers = this.markers_new
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    }
  },
  computed:{
  },
  watch: {
    selected_route_name(val) {
      this.filter_items()
    },
    '$pageVisibility.hidden'(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.resetTimerAndReload();
      }
    }
  }
}
</script>
<style scoped>

.tracking-label {
  opacity: 0.8;
  font-size: 12px;
  bottom: 35px;
  position: relative;
  border: 1px solid black;
  background-color: #333;
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}

.addr-label {
  opacity: 0.8;
  font-size: 12px;
  bottom: -45px;
  position: relative;
  border: 1px solid black;
  background-color: steelblue;
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}
.addr-label-1 {
  opacity: 0.8;
  font-size: 12px;
  bottom: -45px;
  position: relative;
  border: 1px solid black;
  background-color: steelblue;
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}
.addr-label-2 {
  opacity: 0.8;
  font-size: 12px;
  bottom: -68px;
  position: relative;
  border: 1px solid black;
  background-color: steelblue;
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}
</style>
